import moment from 'moment';
class DateFormat {
  static simple(date?: string) {
    return moment(date).format('YYYY/MM/DD');
  }
  static full(date?: string) {
    return moment(date).format('YYYY年MM月DD日 HH时mm分');
  }
}

export default DateFormat;
